import React, { RefObject } from 'react'
import { Filter } from 'components/Filter'
import { FilterButton } from 'components/FilterButton/'
import { ValueType } from 'rsuite/esm/Checkbox'
import type { PublicAdministrationFilterCounts } from './publicAdministrationFilters'
import type { DateRange } from './contracts'
import DateRegisterFilter from 'components/DateRegisterFilter'

interface PublicAdministrationFilterSectionProps {
  filterBarRef: RefObject<HTMLDivElement | null>
  searchTerm: string
  onSearchSubmit: (value: string) => void
  onSearchInputChange: (value: string) => void
  onFilterChange: (type: string, values: ValueType[], checked: boolean) => void
  filterCounts: PublicAdministrationFilterCounts
  totalFilterCount: number
  selectedFilters: Record<string, string[]>
  registerDateRange: DateRange
  onRegisterDateRangeChange: (value: DateRange) => void
}

export const PublicAdministrationFilterSection = ({
  filterBarRef,
  searchTerm,
  onSearchSubmit,
  onSearchInputChange,
  onFilterChange,
  filterCounts,
  totalFilterCount,
  selectedFilters,
  registerDateRange,
  onRegisterDateRangeChange
}: PublicAdministrationFilterSectionProps): JSX.Element => {
  const filterButton = (
    <FilterButton
      variant="publicAdministration"
      filterBarRef={filterBarRef}
      onFilterChange={onFilterChange}
      filterCounts={filterCounts}
      totalFilterCount={totalFilterCount}
      selectedFilters={selectedFilters}
    />
  )

  return (
    <div
      ref={filterBarRef as React.Ref<HTMLDivElement>}
      className="d-flex align-items-center ecosystem-filter-bar"
      style={{
        position: 'relative',
        width: '100%',
        gap: '8px',
        marginTop: '30px',
        marginBottom: '30px'
      }}
    >
      <div className="ecosystem-filter-bar-search" style={{ flex: 1, minWidth: 0 }}>
        <Filter
          filterBarRef={filterBarRef}
          currentSearchTerm={searchTerm}
          btnClick={onSearchSubmit}
          onFilterChange={onSearchInputChange}
          minSearchTermLength={1}
          filterButtonNode={filterButton}
        />
      </div>

      <div className="ecosystem-filtrar-wrapper">
        {filterButton}
      </div>

      <div className="ecosystem-filter-bar-actions d-flex align-items-center" style={{ gap: '8px' }}>
        <div className="ecosystem-date-filter" style={{ flexShrink: 0 }}>
          <DateRegisterFilter
            value={registerDateRange}
            onChange={onRegisterDateRangeChange}
            isArrow={false}
          />
        </div>
      </div>
    </div>
  )
}
